import { render, staticRenderFns } from "./SearchResultMessagesList.vue?vue&type=template&id=2fad2ad9&"
import script from "./SearchResultMessagesList.vue?vue&type=script&lang=js&"
export * from "./SearchResultMessagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports